import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image, Button, Form, InputGroup } from "react-bootstrap";
import AuthLogoCard from "../../components/common/authLogoCard";
import { MESSAGE } from '../../utils/message';
import ForgetPasswordModal from "../../components/common/modal/forgotPassword";
import AlreadyHaveAccount from "../../components/common/alreadyAccount";
import Left_arrow_icon from "../../assests/images/arrow-down.svg";
import Great_Non_Profits_Img from "../../assests/images/ls-page-image/great-nonprofits-img.svg";
import Email_icon from "../../assests/images/ls-page-image/email.svg";
import Key_not_slash_icon from "../../assests/images/ls-page-image/key-not-slash.svg";
import Key_slash_icon from "../../assests/images/ls-page-image/key-slash.svg";
import {
    LoginSection,
    LoginLeftPart,
    LoginRightPart,
    BackToHomeBtn,
    GreatNonProfitsImg,
    UserCreateTitle,
    FormTitle,
    LoginForm,
    FormSubmitBtn,
    ForgotPasswordBtn,
} from "./loginStyle";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { REGEX } from "../../utils/constant";
import { loginUserAction, loginUserHandler } from "../../redux/slices/auth/login-slice";
import { LoginProps } from "../../utils/types";
import MetaComponent from "../../components/common/metaComponent";

const Login = () => {
    const navigate: any = useNavigate();
    const dispatch: any = useDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const login = useSelector((state: any) => state?.login)

    const availableModules = useSelector((state: any) => state?.modules?.data?.results);
    const location = useLocation();
    const [forgetPasswordOpen, setForgetPasswordOpen] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    useEffect(() => {
        if (login?.data) {
            if (login?.data?.status === 200 || login?.data?.status === 202 || login?.data?.status === 201)
                setTimeout(() => {
                    loginUserAction.loginSliceReset();

                    if (typeof localStorage !== "undefined" && localStorage.getItem("reviewPath")) {
                        navigate(typeof localStorage !== "undefined" && localStorage.getItem("reviewPath"));
                    } else {
                        navigate("/");
                    }

                }, 500);
        }
    }, [login])

    useEffect(() => {
        const redirectPath = localStorage.getItem("redirectAfterLogin");
        if (redirectPath) {
            navigate(redirectPath, { replace: true });
            //window.location.href = redirectPath;
            localStorage.removeItem("redirectAfterLogin");
        }
    }, []);

    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validationSchema: Yup.object({
            email: Yup.string().trim().required(MESSAGE.requiredErrors(MESSAGE.emailLabel)).matches(REGEX.emailValidate, MESSAGE.invalidErrors(MESSAGE.emailLabel)),
            password: Yup.string().trim()
                .required(MESSAGE.requiredErrors(MESSAGE.passwordLabel))
            // .matches(
            //     REGEX.passwordValidate,
            //     MESSAGE.passwordValidation
            // )
        }),
        onSubmit: (values: LoginProps, { resetForm }) => {
            const normalizedValues = {
                ...values,
                 email: values.email?.toLowerCase().trim(), 
           };
            dispatch(loginUserHandler(normalizedValues));
            resetForm({});
        },
    });

    return (
        <>
            <MetaComponent
                keywords="nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits"
                description="Sign in to your GreatNonprofits account to share reviews, discover top-rated nonprofits, and contribute to the causes you care about. Join the community today!"
                ogTitle="Sign in | Join GreatNonprofits to Support Nonprofits"
                ogDescription="Sign in to your GreatNonprofits account to share reviews, discover top-rated nonprofits, and contribute to the causes you care about. Join the community today!"
                ogUrl="https://new.greatnonprofits.org/signin"
                ogImage="https://cdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
                twitterTitle="Sign in | Join GreatNonprofits to Support Nonprofits"
                twitterDescription="Sign in to your GreatNonprofits account to share reviews, discover top-rated nonprofits, and contribute to the causes you care about. Join the community today!"
                twitterUrl="https://new.greatnonprofits.org/signin"
                twitterImage="https://cdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
                canonicalUrl="https://new.greatnonprofits.org/signin"
            />
            <LoginSection>
                <Container fluid>

                    <Row className="signUp-col">
                        <LoginLeftPart as={Col} sm={12} md={6} lg={6}>
                            <AuthLogoCard userType="AuthUser" />
                        </LoginLeftPart>
                        <LoginRightPart as={Col} md={6} sm={12} lg={6}>
                            <BackToHomeBtn>
                                <Button onClick={() => navigate("/")} className="back-btn"><Image src={Left_arrow_icon} alt="Back Arrow" width="5px" height="12px" />{MESSAGE.backToWebsite}</Button>
                            </BackToHomeBtn>
                            <GreatNonProfitsImg onClick={() => navigate("/")}>
                                <Image src={Great_Non_Profits_Img} alt="Brand Logo" width="324px" height="24px" />
                            </GreatNonProfitsImg>
                            {location.pathname === "/signin" && <>
                                <UserCreateTitle className="user-login-title">
                                    <FormTitle className="login-title">{MESSAGE.loginFormTitle}</FormTitle>
                                </UserCreateTitle>

                                <LoginForm>
                                    <Form className="login-form" onSubmit={formik.handleSubmit}>
                                        <Form.Group controlId="formBasicEmail" className="form-group">
                                            <InputGroup>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Email address"
                                                    id="email"
                                                    name="email"
                                                    value={formik.values.email}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                <InputGroup.Text>
                                                    <Image src={Email_icon} alt="Email Icon" width="24px" height="24px" />
                                                </InputGroup.Text>
                                            </InputGroup>
                                            {formik.touched.email && formik.errors.email && (
                                                <div className="error">
                                                    <p>{formik.errors.email}</p>
                                                </div>
                                            )}
                                        </Form.Group>
                                        <Form.Group controlId="formBasicPassword" className="form-group">
                                            <InputGroup>
                                                <Form.Control
                                                    type={showPassword ? 'text' : 'password'}
                                                    placeholder="Password"
                                                    id="password"
                                                    maxLength={30}
                                                    name="password"
                                                    value={formik.values.password}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                <InputGroup.Text onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }} >
                                                    <Image src={showPassword ? Key_slash_icon : Key_not_slash_icon} alt="Toggle Password Visibility" width="24px" height="24px" />
                                                </InputGroup.Text>
                                            </InputGroup>
                                            {formik.touched.password && formik.errors.password && (
                                                <div className="error">
                                                    <p>{formik.errors.password}</p>
                                                </div>
                                            )}
                                        </Form.Group>
                                        {availableModules?.forgot_password && <ForgotPasswordBtn>
                                            <Button variant="link" onClick={() => setForgetPasswordOpen(true)}>{MESSAGE.forgotPassword}</Button>
                                            <ForgetPasswordModal editForgetPasswordOpen={forgetPasswordOpen} setForgetPasswordOpen={setForgetPasswordOpen} />
                                        </ForgotPasswordBtn>}
                                        <FormSubmitBtn>
                                            <Button variant="primary" type="submit" className="btn-outline-success-blue"> {MESSAGE.login}
                                                {login?.isLoading && <span className="btnloader"></span>}
                                            </Button>
                                        </FormSubmitBtn>
                                    </Form>

                                    <AlreadyHaveAccount />

                                </LoginForm>
                            </>
                            }
                        </LoginRightPart>
                    </Row>
                </Container>
            </LoginSection>
        </>

    )
};
export default Login; 